module.exports = "<div class=\"ot-loader\">\n  <div class=\"ot-progress\"></div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/common/loader.html
 ** module id = 253
 ** module chunks = 1
 **/